import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageContext';
import { Toaster } from '@/components/ui/sonner';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ScrollToTopButton from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import Matrimoni from '@/pages/Matrimoni';
import Famiglia from '@/pages/Famiglia';
import Eventi from '@/pages/Eventi';
import Ritratti from '@/pages/Ritratti';
import ChiSono from '@/pages/ChiSono';
import FAQ from '@/pages/FAQ';
import Contatti from '@/pages/Contatti';
import Admin from '@/pages/Admin';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTopOnRouteChange />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/matrimoni" element={<Matrimoni />} />
              <Route path="/famiglia" element={<Famiglia />} />
              <Route path="/eventi" element={<Eventi />} />
              <Route path="/ritratti" element={<Ritratti />} />
              <Route path="/chi-sono" element={<ChiSono />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <ScrollToTopButton />
          <Toaster />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
